import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 50 50"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M36.398 0C31.778 0 27.48 2.395 25 6.234 22.52 2.394 18.223 0 13.602 0 6.102 0 0 6.102 0 13.602c0 4.914 4.07 9.656 4.223 9.828l21.086 26.074 20.64-26.14c.164-.188 4.051-4.641 4.051-9.665C50 6.02 44.027 0 36.398 0ZM25 35.2 9 14h7.602L25 26.102 33.398 14H41Z" }, null, -1)
  ])))
}
export default { render: render }